module.exports = __webpack_public_path__ + "static/media/canpass-login.6bfa12c8.png";